import React from 'react';
import ReactDOM from 'react-dom';

function formatValue(value) {
  if (value === null || value === undefined || value === '') return 'N/A';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) return value.length ? value.join(', ') : 'N/A';
  return String(value);
}

function RecordPreviewModal({ open = true, title, subtitle, fields = [], onClose }) {
  if (!open || fields.length === 0) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-x-0 bottom-0 top-20 z-[70] overflow-y-auto bg-slate-950/55 p-4 backdrop-blur-sm sm:top-24 sm:p-6 lg:left-80">
      <div className="mx-auto w-full max-w-3xl overflow-auto rounded-3xl border border-slate-200 bg-white shadow-2xl max-h-full lg:max-w-4xl">
        <div className="sticky top-0 z-10 flex items-center justify-between border-b border-white/10 bg-gradient-to-r from-slate-900 via-blue-950 to-indigo-900 px-6 py-5 text-white">
          <div>
            {subtitle ? <p className="text-xs uppercase tracking-[0.18em] text-blue-200/80">{subtitle}</p> : null}
            <h2 className="mt-1 text-xl font-bold">{title || 'Record Preview'}</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl p-2 text-white/90 transition hover:bg-white/15"
          >
            ✕
          </button>
        </div>

        <div className="grid grid-cols-1 gap-4 p-6 md:grid-cols-2">
          {fields.map((field) => (
            <div key={field.label} className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{field.label}</p>
              <p className="mt-1 text-sm font-semibold text-slate-900 break-words">{formatValue(field.value)}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-end border-t border-slate-200 bg-slate-50 px-6 py-4">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl bg-slate-200 px-4 py-2 font-semibold text-slate-700 transition hover:bg-slate-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default RecordPreviewModal;
